export enum QuantityUnit {
  Piece = 'PIECE',
  Collection = 'COLLECTION',
  Package = 'PACKAGE',
  Pair = 'PAIR',
  Sachet = 'SACHET',
}
